import { IRteParam } from "@contentstack/app-sdk/dist/src/RTE/types";
import { Region } from "@contentstack/app-sdk/dist/src/types";
import { Asset } from "@contentstack/app-sdk/dist/src/types/stack.types";
import { Dispatch, SetStateAction } from "react";
import { KeyValueObj } from "./common/types/types";
import { Entry as EntryType } from '@contentstack/app-sdk/dist/src/types/entry.types'

export interface Position {
  left: number;
  top: number;
}

export interface AIDropDownProps {
  stackUid: string;
  orgUid: string;
  position: Position;
  rteSDK: IRteParam;
  rteLocation: any;
  fixedHeightForDropdown: number;
  pulse: (eventName: string, metadata: {
    [key: string]: any;
  }) => void;
  iframeHeight: number;
  isRteFullScreen: boolean;
}

export enum IMAGE_SOURCE {
  PROMPT = "PROMPT",
  ASSET_OR_DEVICE = "ASSET_OR_DEVICE"
}

export interface ImageGenerationPropsContextType {
  assetBase64?: string;
  closeModal: Function;
  isImageFetching: boolean;
  imageValidationError: string;
  setAssetBase64?: Dispatch<SetStateAction<string>>;
  setAssetInField?: (asset: Object[]) => void,
  allowMultiSelect: boolean,
  appConfig: KeyValueObj | null
}

export interface ImageGenerationAppProps {
  showImageEditor: boolean;
  closeModal: Function;
  deviceOrAssetImage?: Asset[];
  getToken: () => string,
}

export type ImageResponse = Array<{ url: string, base64: string }>

export type ImageGenerationResponse = {
  prompt: string,
  images: ImageResponse,
  editDetails?: {
    image: File;
    mask: File;
  }
}

export interface Template {
  [key: string]: any;
  field_data?: string;
  current_locale?: string;
}

export type Tags = string[]

export interface GetDataOptions {
  useUnsavedSchema?: boolean,
  resolved?: boolean
}

export interface GetTagsOptions {
  useUnsavedSchema: boolean
}

export interface Field {
  data_type: string;
  schema: any;
  uid: string;
  _connection: any;
  getData: (uid?: string, options?: GetDataOptions) => string;
  setData: (data?: Object | string | number) => void;
  value?: any;
  field_metadata?: any;
  enum?: any;
  $uid?: string;
  multiple?: boolean;
  isOpen?: boolean;
  _dummyGroup?: boolean;
}

export interface Entry {
  locale: string;
  getData: () => EntryType;
  getTags: (options: GetTagsOptions) => Tags;
  setTags: (newTags: Tags) => Tags;
  getField: (uid?: string, options?: GetDataOptions) => Field;
}

export type PromptType = "current_field_data" | "different_field_data";

export interface PulseMetaData {
  uid?: string;
  type?: PromptType,
  prompt?: {
    title?: string;
    value?: string;
  };
  retryCount?: number;
  isAccepted?: boolean;
  isCustomCommand?: boolean;
}

export interface GenerateImageRequestBody {
  prompt: string;
  numberOfImages: number
}

export interface EditImageRequestBody extends GenerateImageRequestBody {
  image: File;
  mask: File;
}

export interface GenerateImageRequestBody {
  prompt: string;
  numberOfImages: number
}

export interface GenerateImageParams {
  requestBody: any; //GenerateImageRequestBody | EditImageRequestBody, 
  mode?: "generate" | "edit",
  activePromptPageIndex?: null | number
}

export interface Color {
  color?: string;
}

export interface IContext {
  role: "user" | "assistant" | "system",
  content: string,
  tokenLength: number,
  contextLength: number
}

export interface IChat {
  prompt: string;
  promptLabel: string;
  responses: string[];
  context: IContext[];
}

export interface ITokenUsage {
  inputTokenLength: number,
  outputTokenLength: number
}

export type LoaderType = "circular" | "asyncLoader";

export type StopGenerationIcon = "cancel" | "square"

export interface IVariant {
  name: string,
  shortUid: string,
  audienceCombinationType: string,
  audiences: string[]
}

export interface IAudience {
  name: string,
  description: string
  uid: string
}

export interface ITargeting {
  audience: {
    audienceCombinationType: "AND" | "OR",
    audiences: string []
  }
}

export type IExperienceType = "AB_TEST" | "SEGMENTED"
export interface IExperience {
  shortUid: number,
  __type: IExperienceType,
}

export interface IExperienceVersion {
  experienceUid: string,
  variants: IVariant[],
  status: string,
  uid: string,
}

export enum GenerativeServiceType {
  TEXT_GENERATION = "text_generation",
  NON_STREAMING_TEXT_GENERATION = "non_streaming_text_generation",
  CONVERSE = "converse",
  IMAGE_GENERATION = "image_generation",
  IMAGE_EDIT = "image_edit",
}

export type FieldMetadata = { stackUid?: string, entryUid?: string, fieldUid?: string, type: string }

export type BKLLMConfigType = {
  provider: string;
  model: string;
  model_type: 'recommended' | 'advance';
  service_type: GenerativeServiceType[];
  keys?: any;
  controls?: any;
}

export interface RTEOptions { 
  entryUid: string;
  orgUid: string;
  apiKey: string;
}